import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

/**
 * @name shredder
 * @description Lucide SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTAgMjJ2LTUiIC8+CiAgPHBhdGggZD0iTTE0IDE5di0yIiAvPgogIDxwYXRoIGQ9Ik0xNCAydjRhMiAyIDAgMCAwIDIgMmg0IiAvPgogIDxwYXRoIGQ9Ik0xOCAyMHYtMyIgLz4KICA8cGF0aCBkPSJNMiAxM2gyMCIgLz4KICA8cGF0aCBkPSJNMjAgMTNWN2wtNS01SDZhMiAyIDAgMCAwLTIgMnY5IiAvPgogIDxwYXRoIGQ9Ik02IDIwdi0zIiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/shredder
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const Shredder: IconNode = [
  ['path', { d: 'M10 22v-5' }],
  ['path', { d: 'M14 19v-2' }],
  ['path', { d: 'M14 2v4a2 2 0 0 0 2 2h4' }],
  ['path', { d: 'M18 20v-3' }],
  ['path', { d: 'M2 13h20' }],
  ['path', { d: 'M20 13V7l-5-5H6a2 2 0 0 0-2 2v9' }],
  ['path', { d: 'M6 20v-3' }],
];

export default Shredder;
